import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import {
  AsyncState,
  asyncFailed,
  asyncStart,
  asyncState,
  asyncSuccess,
  createAsyncState,
} from '@ordersnproducts/utils/create-async-state';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import { SalesRegion } from '@cemex-core/cmx-api/models/uploads/sales-region';
import SalesRegionsActions from '../actions/sales-regions.actions';

interface SalesRegionsEntityState extends EntityState<SalesRegion> {
  selectedEntityIds: number[];
  activeEntityId: number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SalesRegionState extends AsyncState<SalesRegionsEntityState> {}

export const adapterSalesRegion: EntityAdapter<SalesRegion> = createEntityAdapter<SalesRegion>({
  selectId: ({ salesRegionId }) => salesRegionId,
});

export const initialSalesRegionState = createAsyncState({
  ...adapterSalesRegion.getInitialState({
    activeEntityId: null,
    selectedEntityIds: [],
  }),
});

export const salesRegionsReducer = createReducer(
  initialSalesRegionState,

  on(SalesRegionsActions.fetch, asyncStart()),

  on(SalesRegionsActions.fetchFailed, asyncFailed()),

  on(
    SalesRegionsActions.fetchSuccess,
    asyncSuccess(({ payload }, state) => ({
      payload: {
        ...adapterSalesRegion.setAll(payload, state.payload),
      },
    })),
  ),

  on(
    SalesRegionsActions.setActive,
    asyncState(({ salesRegionId }, state) => ({
      payload: {
        ...state.payload,
        activeEntityId: salesRegionId,
      },
    })),
  ),

  on(SalesRegionsActions.resetSalesRegionsState, (state) => ({
    ...initialSalesRegionState,
  })),
);

export function reducer(state: SalesRegionState | undefined, action: Action) {
  return salesRegionsReducer(state, action);
}
